import { REGISTER_CLEAR } from 'Reducers/register/types';
import { redirect } from './browser';
import mediator from './mediator';
import { removeSessionObject } from './storage';
import { store } from './store';

// Keep basic URL validation for HTTP(S) and root-relative destinations.
export const getRegistrationReturnUrl = registration_return_uri => /^(https?:\/\/|\/(?!\/))/i.test(registration_return_uri) ? registration_return_uri : undefined;
export const exitRegistration = () => {
  const {
    registration_return_uri
  } = store.getState().env;
  store.dispatch({
    type: REGISTER_CLEAR
  });
  if (registration_return_uri) {
    const exitUrl = getRegistrationReturnUrl(registration_return_uri);
    if (!exitUrl) {
      mediator.publish('router:navigate', '/auth-error');
      return;
    }
    removeSessionObject('authSession');
    removeSessionObject('env');
    removeSessionObject('config');
    redirect(exitUrl);
    return;
  }
  mediator.publish('router:navigate', '/login');
  return;
};